import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    class: "information-container",
    ref: "information-container"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { key: 3 };
const _hoisted_6 = { key: 4 };
const _hoisted_7 = { class: "text-muted text-center p-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SmilesPopupViewer = _resolveComponent("SmilesPopupViewer");
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_MolProps = _resolveComponent("MolProps");
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_Alert = _resolveComponent("Alert");
    const _component_ProteinSequenceViewer = _resolveComponent("ProteinSequenceViewer");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.selectedNodeType === 'compound' && _ctx.smiles !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_SmilesPopupViewer, {
                    width: "100%",
                    maxHeight: 100,
                    smiles: _ctx.smiles
                }, null, 8, ["smiles"]),
                _createVNode(_component_FormWrapper, { cls: "mb-3" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_FormInput, {
                            modelValue: _ctx.smiles,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.smiles) = $event)),
                            readonly: true,
                            placeHolder: "SMILES..."
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }),
                _createVNode(_component_MolProps, {
                    smiles: _ctx.smiles,
                    treeNode: _ctx.treeNode
                }, null, 8, ["smiles", "treeNode"]),
                _createVNode(_component_Alert, {
                    type: "warning",
                    extraStyle: "display: inline-block;",
                    minimal: true
                }, {
                    default: _withCtx(() => [
                        _cache[1] || (_cache[1] = _createTextVNode("These molecular properties depend on protonation. Use ", -1)),
                        _createVNode(_component_PluginPathLink, { plugin: "protonatecomps" }),
                        _cache[2] || (_cache[2] = _createTextVNode(" to protonate your compound(s) at a specific pH. ", -1))
                    ]),
                    _: 1
                })
            ]))
            : (_ctx.selectedNodeType === 'protein' && _ctx.proteinSequenceInfo.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_ProteinSequenceViewer, {
                        sequence: _ctx.proteinSequenceInfo,
                        treeNode: _ctx.treeNode,
                        class: "mb-2"
                    }, null, 8, ["sequence", "treeNode"])
                ]))
                : (_ctx.treeNode === undefined && _ctx.molecules.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("p", { class: "text-muted text-center p-3" }, "Select a protein or compound in the Navigator panel to view its information.", -1)
                        ]))]))
                    : (_ctx.molecules.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("p", { class: "text-muted text-center p-3" }, "No molecules loaded.", -1)
                            ]))]))
                        : (_ctx.selectedNodeType !== 'protein' && _ctx.selectedNodeType !== 'compound' && _ctx.treeNode !== undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("p", _hoisted_7, "Select a protein or compound to view detailed information. Currently selected: " + _toDisplayString(_ctx.treeNode.type) + ".", 1)
                            ]))
                            : _createCommentVNode("", true)
    ], 512));
}
